<template>
  <v-container fluid>
    <v-row>
      <v-col cols="1" class="text-right">
        <v-btn color="primary" @click="addNew()">Dodaj</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Nazwa
              </th>
              <th class="text-left">
                Czy aktywna?
              </th>
              <th class="text-left">
                Adres
              </th>
              <th class="text-left">
                Akcje
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in placowki" :key="item.id">
              <td>{{item.name}}</td>
              <td>{{item.isActive ? "TAK" : "NIE"}}</td>
              <td>{{item.adres}}</td>
              <td><v-icon color="primary" @click="edit(item)" class="mr-2">fa-edit</v-icon></td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <AddEditAddtionalOutposts v-if="showAddEdit" :outpost="outpost" :visible="showAddEdit" @close="closeEdit()" :settingsid="settingsid"></AddEditAddtionalOutposts>
    </v-row>
  </v-container>
</template>

<script>
import {settingsService} from "@/services";
import {mapActions} from "vuex";
import AddEditAddtionalOutposts from "@/components/admin/settings/AddEditAdditionalOutpost.vue";



export default {
  name: "AdditionalOutposts",
  props:["settingsid"],
  components: {AddEditAddtionalOutposts},
  data() {
    return {
      showAddEdit: false,
      placowki: [],
      outpost: null,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions("alert", ["error", "success"]),
    getData() {
      settingsService.getAdditionalOutpotsts().then(result=> {
        this.placowki = result.data.result
      }).catch(() => {
        this.error('Błąd pobierania dodatkowych placówek.')
      })
    },
    edit(item) {
      this.outpost = item
      this.showAddEdit = true
    },
    addNew()
    {
      this.outpost = null
      this.showAddEdit = true
    },
    closeEdit()
    {
      this.outpost = null
      this.showAddEdit = false
      this.getData()
    }
  }
}
</script>

<style scoped>

</style>